/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2547
 */

var r = require(/* 1443 */"./1442/1443")
var i = require(/* 1456 */"./2546/1456/index")
var o = require(/* 865 */"../../../../../253/2568/2569/2570/865/index")
module.exports = function (e) {
  return r(e, o, i)
}
